var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.call
    ? _c("div", [
        !this.answered
          ? _c("div", { staticClass: "video-chat-container" }, [
              _c("div", { staticClass: "answer-container" }, [
                _c("div", { attrs: { id: "calling" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "bouncing-dots",
                      attrs: { "aria-live": "assertive" },
                    },
                    [_vm._v(_vm._s(_vm.$gettext("Llamando...")))]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "decline-call",
                      attrs: { name: "declineCall" },
                      on: { click: this.triggerHangup },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M20 12c0 4.4183-3.5817 8-8 8-1.8487 0-3.551-.6271-4.9056-1.6801L18.3199 7.0944C19.3729 8.449 20 10.1513 20 12zM5.6801 16.9056 16.9056 5.6801C15.551 4.6271 13.8487 4 12 4c-4.4183 0-8 3.5817-8 8 0 1.8487.627 3.551 1.6801 4.9056zM22 12c0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10z",
                            },
                          }),
                        ]
                      ),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$gettext("Finalizar llamada"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ])
          : _c("div", { staticClass: "video-chat-container" }, [
              _c("video", {
                staticClass: "local-video",
                attrs: {
                  id: "localVideo",
                  muted: "",
                  autoplay: "",
                  playsinline: "",
                },
                domProps: { muted: true },
              }),
              _c(
                "div",
                {
                  class: { "fullScreen-container": _vm.fullScreen },
                  attrs: { id: "remoteVideo-container" },
                },
                [
                  _c("video", {
                    ref: "remoteVideo",
                    staticClass: "remote-video",
                    class: { fullScreen: _vm.fullScreen },
                    attrs: { id: "remoteVideo", autoplay: "", playsinline: "" },
                  }),
                  this.videoLoading
                    ? _c("div", { staticClass: "video-loading" })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      class: { "fullScreen-buttons": _vm.fullScreen },
                      attrs: { id: "call-buttons" },
                    },
                    [
                      _c(
                        "div",
                        {
                          class: { "reduce-buttons": _vm.fullScreen },
                          attrs: { id: "top-buttons" },
                        },
                        [
                          _c("button", {
                            staticClass: "action-icon",
                            attrs: {
                              id: "full-screen",
                              "aria-label": !this.fullScreen
                                ? _vm.$gettext("Pantalla completa")
                                : _vm.$gettext("Salir de pantalla completa"),
                              name: "fullScreen",
                            },
                            on: { click: this.toggleFullScreen },
                          }),
                        ]
                      ),
                      _c("div", { attrs: { id: "bottom-buttons" } }, [
                        _c("button", {
                          staticClass: "action-icon mic",
                          class: { muted: _vm.isAudioMuted },
                          attrs: {
                            "aria-label": !this.isAudioMuted
                              ? _vm.$gettext("Activar micrófono")
                              : _vm.$gettext("Desactivar micrófono"),
                            name: "muteButton",
                          },
                          on: { click: this.toggleMute },
                        }),
                        _c("button", {
                          staticClass: "action-icon hangout",
                          attrs: {
                            "aria-label": _vm.$gettext("Finalizar llamada"),
                            name: "hangoutButton",
                          },
                          on: { click: this.triggerHangup },
                        }),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }